import { ref } from 'vue';

import {
  type ObjectCatalogResponse,
  useAccountProductMappingApi,
} from './useAccountProductMappingApi';

type ObjectCatalogItem = ObjectCatalogResponse['items'][number];

export type ObjectCatalogStatus =
  | 'idle'
  | 'loading'
  | 'loaded'
  | 'empty'
  | 'failed';

export function useObjectCatalog(feedId: () => number) {
  const { getObjectCatalog } = useAccountProductMappingApi();

  const status = ref<ObjectCatalogStatus>('idle');
  const objects = ref<ObjectCatalogItem[]>([]);

  async function load() {
    status.value = 'loading';
    const result = await getObjectCatalog(feedId());

    if (result.status !== 200 || !result.data) {
      objects.value = [];
      status.value = 'failed';
      return;
    }

    objects.value = result.data.items;
    status.value = objects.value.length ? 'loaded' : 'empty';
  }

  return { status, objects, load };
}
